export default __webpack_public_path__ + "static/bg-app-754c26a1e9ae5f14a3754d046f2f092c.jpg";